import React from "react";
import { Link } from "react-router-dom";
import "../styles/global.css";
import "../styles/Layout.css";
import { FaInstagram, FaYoutube, FaWhatsapp, FaTelegram } from "react-icons/fa";
import { FaUserPlus } from "react-icons/fa";
import { useState } from "react";



const Layout = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div>
      {/* Header */}
      <header>
        <div className="logo">
          <h1>SARKARI CAREER INFO</h1>
          <p>WWW.SARKARICAREERINFO.COM</p>
        </div>
      
        <nav className="navbar">

          <button
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul className={`nav-menu ${menuOpen ? "show" : ""}`}>

            <li>
              <Link to="/" onClick={() => setMenuOpen(false)}>
                Home
              </Link>
            </li>

            <li>
              <Link to="/latest-jobs" onClick={() => setMenuOpen(false)}>
                Latest Jobs
              </Link>
            </li>

            <li>
              <Link to="/admit-cards" onClick={() => setMenuOpen(false)}>
                Admit Cards
              </Link>
            </li>

            <li>
              <Link to="/admission-forms" onClick={() => setMenuOpen(false)}>
                Admission Forms
              </Link>
            </li>

            <li>
              <Link to="/results" onClick={() => setMenuOpen(false)}>
                Results
              </Link>
            </li>

            <li>
              <Link to="/user-login" onClick={() => setMenuOpen(false)}>
                User Login & Registration
              </Link>
            </li>

          </ul>

        </nav>
      </header>

      {/* Three Column Layout */}
      <div className="page-layout">

        {/* Left Sidebar */}
        <aside className="left-sidebar">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/latest-jobs">Latest Jobs</Link></li>
            <li><Link to="/admit-cards">Admit Cards</Link></li>
            <li><Link to="/results">Results</Link></li>
            <li><Link to="/answer-key">Answer Key</Link></li>
          </ul>
        </aside>

        {/* Main Content */}
        <main className="main-content">
          {children}
        </main>

        {/* Right Sidebar */}
        {/* Right Sidebar */}
        <aside className="right-sidebar">

          {/* Existing Content */}
          <h3>Important Links</h3>
          <ul>
            <li><a href="#">Bank Jobs</a></li>
            <li><a href="#">Railway Jobs</a></li>
            <li><a href="#">SSC Jobs</a></li>
            <li><a href="#">UPSC Jobs</a></li>
          </ul>

          {/* New Social Links Section */}
          <div className="social-section">
            <h3>Follow Us On</h3>

            <div className="social-sidebar">
              <a href="https://instagram.com" className="social-link">
                <FaInstagram size={24} /> <span>Instagram</span>
              </a>

              <a href="https://youtube.com" className="social-link">
                <FaYoutube size={24} /> <span>YouTube</span>
              </a>

              <a href="https://whatsapp.com" className="social-link">
                <FaWhatsapp size={24} /> <span>WhatsApp Channel</span>
              </a>

              <a href="https://telegram.org" className="social-link">
                <FaTelegram size={24} /> <span>Telegram Channel</span>
              </a>
            </div>
          </div>
          {/* User Registration Section */}
          <div className="user-entry-section">
            <h3>Contribute Job Data</h3>

            <Link to="/user-register" className="user-entry-link">
              <FaUserPlus size={24} />
              <span>User Registration</span>
            </Link>

            <Link to="/user-login" className="user-entry-link">
              <FaUserPlus size={24} />
              <span>User Login</span>
            </Link>
          </div>
        </aside>

      </div>

      {/* Footer */}
      <footer>
        <p>&copy; 2025 Sarkari Career Info. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Layout;